{
    "coordinates": [
        54.909951349334534,
        52.71835728712716
    ],
    "tooltip": "Ocher",
    "title": "Ocher Faunal Assemblage Zone",
    "country": "Russia",
    "period": "Permian",
    "alt": "TODO"
}
